import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "swiper/css";
// import "swiper/swiper-bundle.min.css";
import { Card, Row, Spinner } from "react-bootstrap";
import { FlightListInfo } from "./FlightListInfo";
import { PropagateLoader } from "react-spinners";

const FlightListCard = ({
  e,
  handleMoreFare,
  handleClick,
  activeId,
  showModal,
  setShowModal,
  formatTime,
  handlebookmodal,
  handleChnageCurrency,
  fareRules,
  handleClickPhone,
  activeFlightId,
  key,
  moreFare,
  selectedFare,
  setSelectedFare,
  setMoreFare,
  moreFareLoading,
  dataSearch,
}) => {
  function convertMinutesToHrMin(totalMinutes) {
    if (totalMinutes === 0) return "0 m"; // <-- FIXED

    if (!totalMinutes || totalMinutes < 0) return ""; // safety for invalid values

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0) {
      return `${hours} hr ${minutes} m`;
    } else {
      return `${minutes} m`;
    }
  }

  const index = encodeURIComponent(e.ResultIndex);
  const SrdvIndex = e.SrdvIndex ? encodeURIComponent(e.SrdvIndex) : null;
  const flightDealPercentage = localStorage.getItem("flight_deals");
  // console.log("farerules2", fareRules);
  let url = `/flight-detail/${index}/null`;
   let moreUrl = `/flight-detail/${index}/null`;
  if (SrdvIndex) url += `/${SrdvIndex}`;
  const [selected, setSelected] = useState("fr10"); // initially checked

  const handleClicksss = (id) => {
    setSelected((prev) => (prev === id ? null : id)); // toggle if same
  };

  const swiperRef = useRef(null);
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  const checkNavButtons = () => {
    if (swiperRef.current) {
      setShowPrev(!swiperRef.current.isBeginning);
      setShowNext(!swiperRef.current.isEnd);
    }
  };

  useEffect(() => {
    const swiper = swiperRef.current;
    if (swiper) {
      checkNavButtons();
      swiper.on("slideChange", checkNavButtons);
      swiper.on("resize", checkNavButtons);
    }
    return () => {
      if (swiper) {
        swiper.off("slideChange", checkNavButtons);
        swiper.off("resize", checkNavButtons);
      }
    };
  }, []);

  const handleSlideNext = () => {
    const swiper = swiperRef.current;
    if (swiper) {
      const newIndex = Math.min(
        swiper.activeIndex + 3,
        swiper.slides.length - 1
      );
      swiper.slideTo(newIndex, 300); // Smooth transition for buttons
    }
  };

  const handleSlidePrev = () => {
    const swiper = swiperRef.current;
    if (swiper) {
      const newIndex = Math.max(swiper.activeIndex - 3, 0);
      swiper.slideTo(newIndex, 300);
    }
  };

  return (
    <>
      <Card
        style={{
          marginBottom: "15px",
          // , display: e.SrdvIndex==="SrdvTJ" && "none"
        }}
        className="card_styling_flight_listt"
      >
        <Card.Body style={{ padding: "0px" }}>
          <Row style={{ margin: "0px", padding: "0px" }}>
            <div key={e.ResultIndex} style={{ width: "100%", padding: "0px" }}>
              <div key={e.ResultIndex} className="flightDetailDiv">
                <div className="deal">
                  <div className="deal-wrap">
                    <div className="deal-tag fs-10 bold pr v-aligm-m i-b mr-8">
                      DEAL
                    </div>
                    <div className="content i-b v-aligm-m font-lightgrey fs-12">
                      Avail Upto 20% OFF on ICICI Bank Debit Card. Use Code -
                      TGOICIDC
                    </div>
                  </div>
                </div>

                <Row
                  style={{
                    margin: "0px",
                    padding: "0px",
                    marginBottom: 5,
                  }}
                >
                  <div className="flightDetails">
                    <div className="flightImage">
                      <img
                        src={`/Images/AirlineLogo/${e.Segments[0][0].Airline.AirlineCode}.gif`}
                        alt=""
                      />
                      <div className="flightInerPhotoComp">
                        <p style={{ marginBottom: 0 }}>
                          {e.Segments[0][0].Airline.AirlineName}{" "}
                          {e.Segments[0][0].Airline.FlightNumber}
                        </p>
                        {/* <p className="flightBookingDetailslightNumer">{e.flightNumber}</p> */}
                        <p className="flightBookingDetailPrice">
                          ₹{Math.round(e.Fare.PublishedFare)}
                        </p>
                      </div>
                    </div>
                    <div className="flightDetailsDepartureDetails">
                      <div className="departDetails">
                        <p>
                          {new Date(
                            e.Segments[0][0].Origin.DepTime
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                        </p>
                        <p>{e.Segments[0][0].Origin.Airport.CityName}</p>
                      </div>
                      <div className="durationDetails">
                        <p>
                          {" "}
                          <p>
                            {convertMinutesToHrMin(
                              Array.isArray(e.Segments[0])
                                ? e.Segments[0].reduce(
                                    (total, seg) =>
                                      total + (seg?.Duration || 0),
                                    0
                                  )
                                : 0
                            )}
                          </p>
                        </p>
                        {/* <p>{e.Segments[0][0].Duration} m</p> */}
                        <div className="arrow-md-lm flightHorizontal" />
                        <p style={{ textWrap: "nowrap" }}>
                          {/* {e.flightType} */}
                          {e.Segments[0].length - 1 === 0
                            ? "Non-Stop"
                            : `${e.Segments[0].length - 1} Stops`}
                        </p>
                      </div>
                      <div className="arriveDetails">
                        <p>
                          {new Date(
                            e.Segments[0][
                              e.Segments[0].length - 1
                            ].Destination.ArrTime
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                        </p>
                        <p>
                          {
                            e.Segments[0][e.Segments[0].length - 1].Destination
                              .Airport.CityName
                          }
                        </p>
                      </div>
                    </div>
                    <div className="priceDetails">
                      <div>
                        {/* <img
                                  height="15px"
                                  width="15px"
                                  style={{ marginTop: "22px" }}
                                  src={rupee}
                                  alt=""
                              /> */}

                        {dataSearch?.PreferredAirline && (
                          <p
                            style={{
                              fontSize: "14px",
                              textDecoration: "line-through",
                              color: "red",
                              marginBottom: "0px",
                            }}
                          >
                            ₹
                            {Math.round(
                              e.Fare.PublishedFare +
                                (e.Fare.PublishedFare * flightDealPercentage) /
                                  100
                            )}
                          </p>
                        )}
                        <p>₹{Math.round(e.Fare.PublishedFare)}</p>
                      </div>
                      {e.IsUpsellAllowed === true && (
                        <button
                          className="flightBookingMoreFare"
                          onClick={() => handleMoreFare(e.ResultIndex)}
                        >
                          + More Fare
                        </button>
                      )}
                    </div>
                    <Link
                      to={url}
                      // to={{
                      //   pathname: "/flight-detail",
                      //   state: { flightdetails: e },
                      // }}
                      // onClick={()=>handlebooknow()}
                      className="FlightBookingLinkTag"
                    >
                      {" "}
                      <button className="bookButton">BOOK NOW</button>
                    </Link>
                  </div>
                </Row>
                {/* <Row style={{ margin: "0px", padding: "0px" }}>
                <div className="offPriceDiv">
                <p style={{ color: "black" }}>
                  Use Promo code: EASEFLY to get $ 300
                instant discount on
                  this flight
                </p>
              </div>
              </Row> */}
                {/* <Row>
             <div
  className="full-str ng-binding"
  style={{
    padding: "3px 6px",
    color: "#3a3a3a",
    fontSize: 13,
    background: "#fffbed",
    float: "left",
    width: "auto",
    margin: "0 0 7px 15px",
    border: 0,
    borderLeft: "3px solid #efdc9c"
  }}
  id="divNote1"
  ng-show="s.lstFr[0].IST==false && s.lstFr[0].ICPS==false && IsGroupQuery==false"
  ng-bind="s.lstFr[0].Nt"
>
  BOOKNOW: Get extra Rs.310 instant discount on this flight
</div>

             </Row> */}
                <Row style={{ margin: "0px", padding: "0px" }}>
                  <div className="lastDetailDiv">
                    <p
                      onClick={() => {
                        handleClick(e.ResultIndex, e.SrdvIndex);
                      }}
                      style={{ width: "max-content" }}
                    >
                      Flight Detail
                    </p>
                  </div>
                </Row>
              </div>

              {activeId === e.ResultIndex && (
                <FlightListInfo
                  idx={e.ResultIndex}
                  flight={e}
                  handleChnageCurrency={handleChnageCurrency}
                  fareRules={fareRules}
                  SrdvIndex={e.SrdvIndex}
                />
              )}
            </div>
          </Row>
        </Card.Body>

        {/* {showModal === e.ResultIndex && (
          <div
            id="modal-newb2b"
            className="ng-scope"
            style={{ display: "block" }}
          ></div>
        )} */}

        {showModal === e.ResultIndex && (
          <div>
            {!moreFareLoading ? (
              <div>
                {moreFare && moreFare.length !== 0 && (
                  <div
                    id="frOption0"
                    className="modal-newb2b sidenav morefarediv"
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    <div className="modal-content-newb2b">
                      <div className="_lopogt_nhy flx">
                        <div className="_lopogt">
                          <div className="_newrthed">
                            More Fare Options Available
                          </div>
                        </div>
                        <div
                          className="_clouse"
                          onClick={() => {
                            setShowModal(false);
                            setMoreFare(null);
                          }}
                        >
                          <span className="close-newb2b">✖</span>
                        </div>
                      </div>

                      <div className="_nhty flx">
                        <div className="_newdiv-left">
                          <div className="_flitdetls">
                            <div className="flx _bgcls acntr">
                              <div className="_airlilogo">
                                <img
                                  src="https://flight.easemytrip.com/Content/AirlineLogon/AI.png"
                                  alt="airline"
                                />
                              </div>
                              <div className="_detislsnp">
                                <span>
                                  {
                                    moreFare[0].Segments[0][0].Origin.Airport
                                      .CityName
                                  }{" "}
                                  -{" "}
                                  {
                                    moreFare[0].Segments[0][0].Destination
                                      .Airport.CityName
                                  }
                                </span>{" "}
                                {moreFare[0].Segments[0][0].Airline.AirlineName}
                                •{" "}
                                {formatTime(
                                  moreFare[0].Segments[0][0].Origin.DepTime
                                )}{" "}
                                • Departure at{" "}
                                <strong>
                                  {new Date(
                                    moreFare[0].Segments[0][0].Origin.DepTime
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })}
                                </strong>{" "}
                                - Arrival at{" "}
                                <strong>
                                  {new Date(
                                    moreFare[0].Segments[0][
                                      moreFare[0].Segments[0].length - 1
                                    ].Destination.ArrTime
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })}
                                </strong>
                              </div>

                              <div
                                className="_onwdr marg-left"
                                style={{ display: "none" }}
                              >
                                Onward Trip
                              </div>
                              <div
                                className="_fltDtlsd"
                                style={{ display: "none" }}
                              >
                                Flight Details <i className="dwnarrowfl"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <section
                          style={{ position: "relative", padding: "0px 10px" }}
                        >
                          <Swiper
                            speed={100}
                            slidesPerView={5}
                            spaceBetween={10}
                            freeMode={true}
                            freeModeMomentum={true}
                            freeModeMomentumRatio={0.5}
                            freeModeMomentumVelocityRatio={0.4}
                            touchRatio={1.5}
                            resistanceRatio={0.5}
                            simulateTouch={true}
                            breakpoints={{
                              320: { slidesPerView: 4 },
                              480: { slidesPerView: 4 },
                              768: { slidesPerView: 3 },
                              1024: { slidesPerView: 4 },
                              1200: { slidesPerView: 4 },
                            }}
                            onSwiper={(swiper) => {
                              swiperRef.current = swiper;
                              checkNavButtons();
                            }}
                          >
                            {moreFare &&
                              moreFare.map((item) => (
                                <SwiperSlide key={item.ResultIndex || index}>
                                  <div className="_bxses">
                                    <div className="al_flx_opt">
                                      <label className="ng-scope">
                                        <div
                                          className={`pls_bxs f_bx lun frOUT ${
                                            selectedFare?.ResultIndex ===
                                            item.ResultIndex
                                              ? "actve"
                                              : ""
                                          }`}
                                        >
                                          {/* <div className="pls_bxs f_bx lun frOUT actve"> */}
                                          <div className="upr_sctn">
                                            <div className="flx_p">
                                              <div className="dtl_plus">
                                                <div className="optn_head">
                                                  <span>
                                                    {
                                                      item.UpsellOptionsList
                                                        .UpsellList[0]
                                                        .FareFamilyName
                                                    }
                                                  </span>
                                                </div>
                                                <div className="prce_mn ng-binding">
                                                  {dataSearch?.PreferredAirline && (
                                                    <p
                                                      style={{
                                                        fontSize: "14px",
                                                        textDecoration:
                                                          "line-through",
                                                        color: "red",
                                                      }}
                                                    >
                                                      ₹
                                                      {Math.round(
                                                        item.Fare
                                                          .PublishedFare +
                                                          (item.Fare
                                                            .PublishedFare *
                                                            flightDealPercentage) /
                                                            100
                                                      )}
                                                    </p>
                                                  )}
                                                  <div className="prce_mn ng-binding">
                                                    ₹{" "}
                                                    {Math.round(
                                                      item.Fare.PublishedFare
                                                    )}
                                                  </div>
                                                  <div className="clr"></div>
                                                </div>
                                              </div>
                                              <div className="slct_optn">
                                                <label className="conta-radio">
                                                  <input
                                                    type="radio"
                                                    className="ddsd"
                                                    name="fareOption"
                                                    checked={
                                                      selectedFare?.ResultIndex ===
                                                      item.ResultIndex
                                                    }
                                                    onChange={() =>
                                                      setSelectedFare(item)
                                                    }
                                                  />
                                                  <span className="checkk-radio"></span>
                                                </label>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="faclty">
                                            {item.Segments[0][0].Baggage !==
                                              null &&
                                              item.Segments[0][0].Baggage !==
                                                "" && (
                                                <div className="_fcltechdt fflx fjsb">
                                                  <i>
                                                    <img
                                                      src="https://flight.easemytrip.com/Content/img/more-fare/bageicn.svg"
                                                      alt="baggage"
                                                    />
                                                  </i>
                                                  <div className="_dsrcp_rpt fclm">
                                                    <div className="_tpbldtle">
                                                      Baggage
                                                    </div>
                                                    <ul>
                                                      <li className="_cabinfcnl">
                                                        <strong>
                                                          {
                                                            item.Segments[0][0]
                                                              .CabinBaggage
                                                          }
                                                        </strong>{" "}
                                                        Cabin Baggage
                                                      </li>
                                                      <li className="_cabinfcnl">
                                                        <strong>
                                                          {
                                                            item.Segments[0][0]
                                                              .Baggage
                                                          }{" "}
                                                          &nbsp;
                                                        </strong>
                                                        <span>
                                                          Check-in Baggage
                                                        </span>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </div>
                                              )}

                                            {/* {item.MiniFareRules && (
    <div className="_fcltechdt fflx fjsb">
                              <i>
                                <img
                                  src="https://flight.easemytrip.com/Content/img/more-fare/flxicn.svg"
                                  alt="flexibility"
                                />
                              </i>
                              <div className="_dsrcp_rpt fclm">
                                <div className="_tpbldtle">Changeability</div>
                                <ul>
                                  <li className="_cabinfcnl">
                                    Cancellation fee starts at{" "}
                                    <strong>
                                      ₹ {handleChnageCurrency("2500")}
                                    </strong>
                                  </li>
                                  <li className="_cabinfcnl">
                                    Date Change fee starts at{" "}
                                    <strong>
                                      ₹ {handleChnageCurrency("2750")}
                                    </strong>
                                  </li>
                                </ul>
                              </div>
                            </div>
)} */}
{item?.UpsellOptionsList?.UpsellList?.[0]?.ServicesList
  ?.filter((dat) => {
    const code = dat?.UpsellDescription?.split("|")?.[0]; 
    return ["059"].includes(code);
  })
  ?.map((data, i) => (
    <div className="_fcltechdt fflx fjsb" key={i}>
      <i>
        <img
          src="https://flight.easemytrip.com/Content/img/more-fare/flxicn.svg"
          alt="add on"
        />
      </i>
      <div className="_dsrcp_rpt fclm">
        <div className="_tpbldtle">{data.UpsellDescription}</div>
      </div>
    </div>
  ))}

                                            {/* {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
                                              (dat) =>
                                                ["059"].includes(
                                                  dat.Code.toString()
                                                )
                                            ).map((data) => (
                                              <div className="_fcltechdt fflx fjsb">
                                                <i>
                                                  <img
                                                    src="https://flight.easemytrip.com/Content/img/more-fare/flxicn.svg"
                                                    alt="add on"
                                                  />
                                                </i>
                                                <div className="_dsrcp_rpt fclm">
                                                  <div className="_tpbldtle">
                                                    {data.UpsellDescription}
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                            <div className="_fcltechdt fflx fjsb">
                                              <i>
                                                <img
                                                  src="https://flight.easemytrip.com/Content/img/more-fare/seaticn.svg"
                                                  alt="add on"
                                                />
                                              </i>
                                              <div className="_dsrcp_rpt fclm">
                                                <div className="_tpbldtle">
                                                  Add-ons
                                                </div>
                                                {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
                                                  (dat) =>
                                                    ["0B5"].includes(
                                                      dat.Code.toString()
                                                    )
                                                ).map((data) => (
                                                  <ul>
                                                    {data.IsIncluded ===
                                                      "Yes" && (
                                                      <li className="_cabinfcnl">
                                                        <strong>
                                                          Pre Reserved Seat
                                                          Assignment
                                                        </strong>{" "}
                                                      </li>
                                                    )}{" "}
                                                  </ul>
                                                ))}
                                                {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
                                                  (dat) =>
                                                    ["0B3"].includes(
                                                      dat.Code.toString()
                                                    )
                                                ).map((data) => (
                                                  <ul>
                                                    {data.IsIncluded ===
                                                      "Yes" && (
                                                      <li className="_cabinfcnl">
                                                        <strong>
                                                          Complimentary Meals
                                                        </strong>{" "}
                                                      </li>
                                                    )}{" "}
                                                  </ul>
                                                ))}
                                              </div>
                                            </div> */}
                                            <div className="_fcltechdt fflx fjsb">
  <i>
    <img
      src="https://flight.easemytrip.com/Content/img/more-fare/seaticn.svg"
      alt="add on"
    />
  </i>

  <div className="_dsrcp_rpt fclm">
    <div className="_tpbldtle">Add-ons</div>

    {/* Pre Reserved Seat Assignment */}
    {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
      (dat) => ["0B5"].includes((dat.Code ?? "").toString())
    ).map((data, idx) => (
      <ul key={`seat-${idx}`}>
        {data.IsIncluded === "Yes" && (
          <li className="_cabinfcnl">
            <strong>Pre Reserved Seat Assignment</strong>
          </li>
        )}
      </ul>
    ))}

    {/* Complimentary Meals */}
    {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
      (dat) => ["0B3"].includes((dat.Code ?? "").toString())
    ).map((data, idx) => (
      <ul key={`meal-${idx}`}>
        {data.IsIncluded === "Yes" && (
          <li className="_cabinfcnl">
            <strong>Complimentary Meals</strong>
          </li>
        )}
      </ul>
    ))}
  </div>
</div>

                                            {item.IsRefundable && (
                                              <div className="_rfndle _rfndle">
                                                Refundable
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </SwiperSlide>
                              ))}
                          </Swiper>

                          {showNext && (
                            <div
                              className="custom-next3 flight_list_custom-next3"
                              onClick={handleSlideNext}
                            >
                              <FaChevronRight
                                color="#1d489f"
                                className="fav_chevronnr"
                              />
                            </div>
                          )}

                          {showPrev && (
                            <div
                              className="custom-prev3"
                              onClick={handleSlidePrev}
                            >
                              <FaChevronLeft
                                color="#1d489f"
                                className="fav_chevronnr"
                              />
                            </div>
                          )}
                        </section>
                      </div>
                      {selectedFare && (
                        <div className="_btmftrdv">
                          <div className="_emtfxder">
                            <div className="_btnm flx acntr jsb">
                              <div className="_nhyuop">
                                <div className="_prgty">Grand Total</div>
                                <div className="_finpric f30">
                                  {dataSearch?.PreferredAirline && (
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "line-through",
                                        color: "red",
                                      }}
                                    >
                                      ₹
                                      {Math.round(
                                        selectedFare.Fare.PublishedFare +
                                          (selectedFare.Fare.PublishedFare *
                                            flightDealPercentage) /
                                            100
                                      )}
                                    </span>
                                  )}
                                  <span>
                                    ₹{" "}
                                    {Math.round(
                                      selectedFare.Fare.PublishedFare
                                    )}
                                  </span>
                                </div>
                              </div>
                              <Link
                                className="book-bt-nwap marg-left"
                                // onClick={() =>
                                //   handlebookmodal(
                                //     selectedFare.ResultIndex,
                                //     selectedFare
                                //   )
                                // } // pass selected fare
                                // to={url}
                                 onClick={() =>
                                    handlebookmodal(
                                      selectedFare.ResultIndex,
                                      selectedFare
                                    )
                                  }
                                  to={`/flight-detail/${selectedFare.ResultIndex}/null`}
                                  style={{cursor:"pointer"}}
                              >
                                Book Now
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div
                id="modal-newb2b"
                // className="modal-newb2b sidenav morefarediv"
                style={{
                  display: "block",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBlock: "auto",
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  <PropagateLoader color="#d32f2f" />
                </div>
              </div>
            )}
          </div>
        )}
      </Card>
      <div className="ng-scope flight_list_TG_phone">
        <div className="fltResult">
          <div className="fligt-cntnr">
            <div className="adodis ng-binding ng-hide" id="sCTUP1">
              <img
                src="https://flight.EaseMyTrip.com/Content/img/discount-icon.svg"
                alt="Discount"
              />
            </div>

            <div className="ctr-dv">
              <Link className="managlist1" to={url}>
                <div className="fl_logo">
                  <div ng-if="isDomestic" className="ng-scope">
                    <img
                      src={`/Images/AirlineLogo/${e.Segments[0][0].Airline.AirlineCode}.gif`}
                      alt="airline"
                      style={{ width: 30, borderRadius: 5 }}
                    />
                  </div>
                </div>
                <div>
                  <span className="fl_deprt ng-binding">
                    {" "}
                    {new Date(
                      e.Segments[0][0].Origin.DepTime
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </span>
                </div>
                <div className="fl_info_col">
                  <div className="duratn-bdr text-center append_bottom10">
                    <span className="gray_dot--solid sml-dot-l" />

                    <span className="text_gray text-center ng-binding">
                      {e.Segments[0][0].Duration} m
                    </span>

                    <span className="gray_dot--solid sml-dot-r" />
                  </div>

                  <p className="text_gray_n text-center ng-scope">
                    {e.Segments[0].length - 1 === 0
                      ? "Non-Stop"
                      : `${e.Segments[0].length - 1} Stops`}
                  </p>
                </div>
                <div>
                  <span className="fl_arive ng-binding">
                    {new Date(
                      e.Segments[0][
                        e.Segments[0].length - 1
                      ].Destination.ArrTime
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </span>
                </div>
                <div className="fl_cost">
                  <span className="ti_prc ng-scope" ng-if="IsGroupQuery==false">
                    {dataSearch?.PreferredAirline && (
                      <span
                        className="ttl_b_amt ng-binding ng-scope"
                        id="spnPrice1"
                        style={{
                          textDecoration: "line-through",
                          color: "red",
                          fontSize: "10px",
                        }}
                      >
                        ₹
                        {Math.round(
                          e.Fare.PublishedFare +
                            (e.Fare.PublishedFare * flightDealPercentage) / 100
                        )}
                      </span>
                    )}
                    <span
                      className="ttl_b_amt ng-binding ng-scope"
                      id="spnPrice1"
                    >
                      ₹{Math.round(e.Fare.PublishedFare)}
                    </span>
                  </span>

                  <div className="clr" />
                </div>
              </Link>
              <hr style={{ margin: "0px", border: "0.6px solid #b4b3b3" }} />
              <div className="flight_light_inner_phone">
                <div>
                  <p className="phone_flight_innerp">
                    {" "}
                    {e.Segments[0][0].Airline.AirlineName}
                  </p>
                  <p className="phone_flight_innerp2">
                    {" "}
                    {e.Segments[0][0].Airline.AirlineCode}-
                    {e.Segments[0][0].Airline.FlightNumber}
                  </p>
                </div>
                <div style={{ textAlign: "end" }}>
                  <a
                    className="mfrebtn morebuttonlist ng-scope"
                    // onClick={() => {
                    //   handleMoreFare(e.ResultIndex, e.SrdvIndex);
                    // }}
                  >
                    {" "}
                    {e.IsUpsellAllowed === true ? (
                      <>
                        {activeFlightId === e.ResultIndex ? (
                          " - Less Fare"
                        ) : (
                          <span onClick={() => handleMoreFare(e.ResultIndex)}>
                            + More Fare
                          </span>
                        )}
                      </>
                    ) : (
                      <Link to={url}>Book Now</Link>
                    )}
                    {/* {activeFlightId === e.ResultIndex
                      ? " - Less Fare"
                      : "+ More Fare"} */}
                  </a>
                  <p
                    style={{
                      color: "#4CAF50",
                      fontSize: "10px",
                      fontWeight: "500",
                    }}
                  >
                    Get Rs 200 Off | code BOOKNOW
                  </p>
                </div>
              </div>
              {/* <a
                  className="mfrebtn morebuttonlist ng-scope"
                  id="divMoreFare0"
                  style={{ display: "block", marginTop: 0 }}
                  onClick={()=>setActiveFlight(!activeFlight)}
                >
                 {activeFlight ? " - Less Fare" : "+ More Fare"}
                </a>

                

           
                <div
                  style={{
                    float: "right",
                    fontSize: 9,
                    fontWeight: 600,
                    background: "#fcf8e3",
                    borderRadius: 20,
                    padding: "2px 5px",
                    marginLeft: 8,
                    color: "#8a6d3b",
                    display: "block",
                    marginTop: 3,
                    marginBottom: 3,
                  }}
                  className="ng-binding ng-scope"
                />

                <div className="clr" />

                <div
                  style={{
                    fontSize: "9.5px",
                    padding: "3px 2px",
                    color: "#3a3a3a",
                    background: "#fdecd6",
                    marginTop: 7,
                    textAlign: "left",
                    float: "left",
                    borderLeft: "3px solid #fdd19f",
                  }}
                  id="divNote1"
                  className="ng-binding ng-scope"
                >
                  BOOKNOW: Get extra Rs.310 instant discount on this flight
                </div> */}
            </div>

            <div className="clr" />

            {activeFlightId === e.ResultIndex && (
              <div>
                {!moreFareLoading ? (
                  <>
                    {" "}
                    {moreFare &&
                      moreFare.map((item) => (
                        <div
                          className="corulmain multifr"
                          id="frOption0"
                          style={{ display: "block" }}
                        >
                          <div className="corboxuli ng-scope">
                            <label className="container-heduredi">
                              <div className="mobli">
                                <div className="heduredi">
                                  <div className="nw-far-oth  ng-binding">
                                    {
                                      item.UpsellOptionsList.UpsellList[0]
                                        .FareFamilyName
                                    }
                                    <input
                                      type="radio"
                                      className="ng-scope"
                                      name="fareOption"
                                      checked={
                                        selectedFare?.ResultIndex ===
                                        item.ResultIndex
                                      }
                                      onChange={() => setSelectedFare(item)}
                                    />
                                    <span className="checkmark-heduredi" />
                                  </div>
                                </div>

                                <ul>
                                  {item.Segments[0][0].CabinBaggage !== null &&
                                    item.Segments[0][0].CabinBaggage !== "" && (
                                      <li>
                                        <div className="mbflex">
                                          <div className="iconColm">
                                            <img src="https://flight.EaseMyTrip.com/content/img/cabin-baggage.svg" />
                                          </div>
                                          <div className="calwid">
                                            <span className="ftn11_mf">
                                              Cabin Bag :{" "}
                                            </span>

                                            <span className="sbdtl_mf ng-scope">
                                              {item.Segments[0][0].CabinBaggage}
                                            </span>
                                          </div>
                                        </div>
                                      </li>
                                    )}
                                  {item.Segments[0][0].Baggage !== null &&
                                    item.Segments[0][0].Baggage !== "" && (
                                      <li>
                                        <div className="mbflex">
                                          <div className="iconColm">
                                            <img src="https://flight.EaseMyTrip.com/content/img/checkin-baggage.svg" />
                                          </div>
                                          <div className="calwid">
                                            <span className="ftn11_mf">
                                              Check in :{" "}
                                            </span>
                                            <span className="sbdtl_mf ng-binding">
                                              {item.Segments[0][0].Baggage}
                                            </span>
                                          </div>
                                        </div>
                                      </li>
                                    )}
                                {item?.UpsellOptionsList?.UpsellList?.[0]?.ServicesList
  ?.filter((dat) => {
    const code = dat?.UpsellDescription?.split("|")?.[0]; 
    return ["059"].includes(code);
  })
  ?.map((data, i) => (
                                    <li>
                                      <div className="mbflex">
                                        <div className="iconColm">
                                          <img src="https://flight.EaseMyTrip.com/content/img/cancellation-icon.svg" />
                                        </div>
                                        <div className="calwid">
                                          <span className="ftn11_mf">
                                            {data.UpsellDescription}
                                          </span>

                                          {/* <span className="sbdtl_mf ng-binding ng-scope">
                                      Rs 4240 onwards
                                    </span> */}
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                 
                                    {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
      (dat) => ["0B5"].includes((dat.Code ?? "").toString())
    ).map((data, idx) => (
                                    <li
                                      style={{ display: "block" }}
                                      className="ng-scope"
                                    >
                                      <div className="mbflex ng-scope">
                                        <div className="iconColm">
                                          <img src="https://flight.easemytrip.com/content/img/seat-icon-nw.svg" />
                                        </div>
                                        <div className="calwid">
                                          <span className="ftn11_mf">
                                            {" "}
                                            {data.IsIncluded === "Yes" &&
                                              " Pre Reserved Seat Assignment"}{" "}
                                          </span>
                                          {/* <span className="sbdtl_mf">Free seat</span> */}
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                   {item.UpsellOptionsList.UpsellList[0].ServicesList.filter(
      (dat) => ["0B3"].includes((dat.Code ?? "").toString())
    ).map((data, idx) => (
                                    <li
                                      style={{ display: "block" }}
                                      className="ng-scope"
                                    >
                                      <div className="mbflex ng-scope">
                                        <div className="iconColm">
                                          <img src="https://flight.easemytrip.com/content/img/meal-icon-nw.svg" />
                                        </div>
                                        <div className="calwid">
                                          <span className="ftn11_mf">
                                            {data.IsIncluded === "Yes" &&
                                              "Complimentary Meals"}{" "}
                                          </span>
                                          {/* <span className="sbdtl_mf">
                                        Complimentary meals
                                      </span> */}
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </label>
                            <div className="main-btn">
                              <div className="price-tbe">
                                {/* <span className="CurrncyCD_Rs pricr-nerw" /> */}
                                {dataSearch?.PreferredAirline && (
                                  <span
                                    className="pricr-nerw ng-binding ng-scope"
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "line-through",
                                      color: "red",
                                    }}
                                  >
                                    ₹
                                    {Math.round(
                                      item.Fare.PublishedFare +
                                        (item.Fare.PublishedFare *
                                          flightDealPercentage) /
                                          100
                                    )}
                                  </span>
                                )}
                                <span className="pricr-nerw ng-binding ng-scope">
                                  ₹{item.Fare.PublishedFare}
                                </span>
                              </div>
                              <div className="btsub">
                                <Link
                                  className="btn  book-bt-n"
                                  onClick={() =>
                                    handlebookmodal(
                                      selectedFare.ResultIndex,
                                      selectedFare
                                    )
                                  }
                                   to={`/flight-detail/${selectedFare.ResultIndex}/null`}
                                  // to={url}
                                >
                                  {" "}
                                  Book Now
                                </Link>
                              </div>
                            </div>
                            <div className="clr" />
                          </div>
                        </div>
                      ))}
                  </>
                ) : (
                  <div
                    style={{
                      padding: "10px 5px",
                      fontSize: "12px",
                      textAlign: "center",
                      margin: "auto",
                      width: "100%",
                    }}
                  >
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Please wait while more fare is loading....
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FlightListCard;
